define(function(require) {
  const tpl = require('civicsViews/new_attachments/templates/t_itv_attachment.hbs');
  const ViewManager = require('civicsUtils/view_manager');
  const AttachmentModel = require('civicsModels/attachment_model');

  const ConfirmationModal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');
  const imgThumbnailHeight = 100;

  const Radio = require('backbone.radio');
	const AddAttachmentChannel = Radio.channel('addAttachmentChannel');

  return Marionette.ItemView.extend({
    template: tpl,
    regions: {
      constraintsRegion: '.constraints-region',
      listRegion: '.list-region'
    },
    ui: {
      'downloadLink': '.download-link',
      'attachmentThumbnail': '.attachment-thumbnail',
      'deleteLink': '.delete-link',
      'detailsLink': '.details-link',
      'iconPreview': '.file-icon-preview',
      'imagePreview': '.image-thumbnail',
    },
    events: {
      'click @ui.downloadLink': 'downloadAttachmentClicked',
      'load .attachment-thumbnail': 'setImageSize',
      'click @ui.deleteLink': 'deleteAttachmentClicked',
      'click @ui.detailsLink': 'detailsClicked'
    },
    className: 'new-attachment-item',
    tagName: 'li',
    initialize: function(options) {
      this.config = options.config;
      this.productFamily = options.productFamily;
      this.modalRegion = options.modalRegion;
      this.isReviewProcess = options.isReviewProcess;
      this.isAddProcess = options.isAddProcess;
      this.showDocumentType = options.showDocumentType;
      this.permissions = options.permissions;
      this.collection = options.collection;
      this.parentMoniker = options.parentMoniker;
      this.parentPrimaryKey = options.parentPrimaryKey;
      this.documentTypeCollection = options.documentTypeCollection;
      this.documentType = options.documentType;
      this.rawAttachments = options.rawAttachments;
      this.randId = Math.floor(Math.random()*100000);
      
    },
    onRender: function() {},
    onShow: function() {
      if(this.isAddProcess) {
        this.ui.imagePreview.hide();
        this.ui.iconPreview.hide();
        this.previewAttachmentIconThumbnail(this.ui.imagePreview, this.ui.iconPreview);
      }
    },
    setImageSize: function() {
      var height = $image.naturalHeight;
      var width = $image.naturalWidth;
    },
    previewAttachmentIconThumbnail: function() {
			var self = this;

			var mimeType = self.model.get('File').get('Type');
			if (mimeType != undefined && typeof self.ui.imagePreview === 'object' || typeof this.ui.iconPreview === 'object') {
				if (mimeType != null && mimeType.split('/')[0] === 'image') {
					var attachmentReader = new FileReader();
					attachmentReader.onload = function(e) {
						if (typeof self.ui.imagePreview === 'object') {
							var image = new Image();
							image.src = e.target.result;
							self.imgUrl = e.target.result;
							image.onload = function() {
								if (typeof this.height !== 'undefined' && this.height < imgThumbnailHeight && this.height > 0) {
									self.ui.imagePreview.height(this.height);
								} else {
									if (this.height > this.width) {
										self.ui.imagePreview.height(imgThumbnailHeight);
									} else {
										self.ui.imagePreview.width(imgThumbnailHeight);
									}
								}
								self.ui.imagePreview.attr('src', image.src);
							}
						}
					}
					var fileName = self.model.get('filename');
					if (fileName && fileName.length > 0) {
						if (self.rawAttachments.models) {
							var newAttachment = self.rawAttachments.where({
								fileName: fileName
							});
							if (newAttachment.length == 1) {
								var file = newAttachment[0].get("file");
							}
						} else {
							var newAttachment = _.findWhere(self.rawAttachments, {
								fileName: fileName
							});
							if (newAttachment) {
								var file = newAttachment.file;
							}
						}
						if (file && file instanceof Blob) {
							attachmentReader.readAsDataURL(file);
							self.file = file;
							self.ui.imagePreview.show();
						}
					}
				} else {
					self.ui.iconPreview.show();
				}
			}
		},
    downloadAttachmentClicked: function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    //  this.triggerMethod('singleDownload:clicked',this.model.get('documentUri'));
      AddAttachmentChannel.trigger('singleDownload:clicked', this.model.get('documentUri'));

    },
    deleteAttachmentClicked: function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      
      if (!this.isAddProcess) {
        this.modalView = new ConfirmationModal({
          title: i18n.t('CIVICS.COMMON.CONFIRMATION'),
          instructions: i18n.t('CIVICS.COMMON.DELETE_ATTACHMENT'),
          applicationTitle: this.model.get('title') + ' (' + this.model.get('filename') + ')',
          cancelButtonText: i18n.t('CIVICS.COMMON.BACK'),
          submitButtonText: i18n.t('CIVICS.COMMON.DELETE'),
          confirmationCallback: this.deleteConfirmation.bind(this),
          modalRegion: this.modalRegion,
        });
      } else {
        this.modalView = new ConfirmationModal({
          title: i18n.t('CIVICS.COMMON.CONFIRMATION'),
          instructions: i18n.t('CIVICS.ATTACHMENTS.REMOVE_ATTACHMENT'),
          cancelButtonText: i18n.t('CIVICS.COMMON.NO'),
          submitButtonText: i18n.t('CIVICS.COMMON.YES'),
          confirmationCallback: this.deleteConfirmation.bind(this),
          modalRegion: this.modalRegion,
        });
      }

      this.modalRegion.show(this.modalView);
      this.modalRegion.showModal();
    },
    deleteConfirmation: function() {
      var self = this;
      var deletePromise = $.Deferred();

      if (!self.isAddProcess) {
        ViewManager.loading(true);

        var attachmentModel = new AttachmentModel(self.model.toJSON());
        attachmentModel.isDelete = true;
        attachmentModel.set('parentMoniker', self.parentMoniker);
        attachmentModel.set('parentPrimaryKey', self.parentPrimaryKey);

        attachmentModel.destroy({
          data: {
            "provider": attachmentModel.get('provider')
          },
          success: function(model, response) {
            ViewManager.loading(false);
            self.modalRegion.hideModal();
            self.triggerMethod('attachments:delete',self.model);

          },
          error: function(model, response) {
            ViewManager.loading(false);
            self.modalRegion.hideModal();
            ViewManager.errorToWindow(response, self);

          }
        });
      } else {
        this.modalRegion.hideModal();
        this.triggerMethod('attachments:delete', this.model);
      }
    },
    detailsClicked: function(e) {
      e.preventDefault();
      var self = this;

      self.triggerMethod('details:clicked',self.model,self.file);

    },
    getDocumentTypeDisplay: function() {
			var self = this;
      //Get the name provided with the attachment in case we dont have the doc type in the list.
      var defaultName = self.model.get('documentType').get('name');
      var description = self.model.get('documentType').get('description');
      var portalDescription = self.model.get('documentType').get('portalDescription');
      var displayName = defaultName;

      //Loop through each doc type in the constraint collection to get the additional details
			var mydocumentType = this.documentTypeCollection.find(function(doctype) {
				 return doctype.get('name') == defaultName;
			});

      if( mydocumentType != null){
        displayName = this.documentType.get('description') != null ?  this.documentType.get('description') : this.documentType.get('name');
       }else if(portalDescription){
         displayName = portalDescription;
       }else if(description){
         displayName = description;
      }

      //check if we need to default to original name
      displayName = displayName ? displayName : defaultName;
      return displayName;
		},
    getHtmlId: function() {
      if(this.model.get('id')== null || this.model.get('id').length ==0) {
        return  this.randId;
      }
      return this.model.get('id');
    },
    templateHelpers: function() {
      var fileName =  this.model.get('filename') != null ? this.model.get('filename') : '';
      var fileType = fileName.substring(fileName.lastIndexOf('.'));
      var hasMissingRequirements = (this.isAddProcess) ? this.model.get('missingRequirements').length > 0 : false;
      var missingRequirementsLabel =  i18n.t('CIVICS.ATTACHMENTS.ATTACHMENT_MISSING_REQUIREMENTS', {
        id: fileName
      });
      let virusScanStatus = this.model.get('virusScanResults')?.toJSON() || {safe:true};
      return {
        breakUnderscores: function(text) {
          if (!text) return '';
          // First escape HTML to prevent XSS, then add zero-width spaces for word breaks
          var escaped = Handlebars.helpers['global:sanitize'](text, { hash: { allowedTags: 'br' } });
          return escaped.replace(/_/g, "&#8203;_");
        },
        filenameToDisplay: fileName,
				fileType: fileType,
        showDeleteLink: (this.permissions.delete || this.isAddProcess),
        showDownloadLink: virusScanStatus.safe && (this.permissions.open &&  !this.isAddProcess && !this.isReviewProcess),
        showDetails: this.permissions.open || this.isAddProcess || this.isReviewProcess,
        hasModalLink: virusScanStatus.safe && (this.isAddProcess || this.permissions.open),
        showDocumentType: this.showDocumentType &&  (this.permissions.open || this.isAddProcess || this.isReviewProcess || this.permissions.list),
        showThumbnail: this.permissions.open,
        showDefaultImage: (this.permissions.open || this.isAddProcess || this.isReviewProcess || this.permissions.list),
        documentType: this.getDocumentTypeDisplay(),
        addedDate: this.model.get('addedDateTime') ? this.model.get('addedDateTime') : '',
        hasMissingRequirements: hasMissingRequirements,
        missingRequirementsLabel:missingRequirementsLabel,
        isReviewProcess: this.isReviewProcess,
        isAddProcess: this.isAddProcess,
        thumbnailPath: this.model.get('thumbnailUri'),
        attachmentImageId: this.getHtmlId() + '_'+ fileName.replace(/\W/g, ''),
        htmlId: this.getHtmlId(),
				pendingStatus: virusScanStatus.pending === true,
				infectedStatus: virusScanStatus.infected === true
      };
    }
  });
});
